module.exports = {
      id: "hoversearch-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#hoversearch",
      toString: function () {
        return this.url;
      }
    }